export default __webpack_public_path__ + "static/media/favicon.fad0ca54.ico";